"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextboxStateWrapper = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.RichTextViewer = exports.PSQImage = exports.PSQShortText = void 0;
var React = require("react");
var csod = require("player-core");
var ViewSF_1 = require("./ViewSF");
var PSQImage_1 = require("../PSQImage/PSQImage");
Object.defineProperty(exports, "PSQImage", { enumerable: true, get: function () { return PSQImage_1.PSQImage; } });
var player_rich_text_viewer_1 = require("player-rich-text-viewer");
exports.RichTextViewer = player_rich_text_viewer_1.default;
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var TextboxStateWrapper_1 = require("../TextboxStateWrapper/TextboxStateWrapper");
Object.defineProperty(exports, "TextboxStateWrapper", { enumerable: true, get: function () { return TextboxStateWrapper_1.TextboxStateWrapper; } });
var PSQShortText = (function (_super) {
    __extends(PSQShortText, _super);
    function PSQShortText(props) {
        var _this = _super.call(this, props) || this;
        _this.packageName = 'player-application-workflow';
        _this._renderView = _this._renderView.bind(_this);
        _this.viewSF = ViewSF_1.viewSF.apply(_this);
        _this.viewSF.constructor && _this.viewSF.constructor.apply(_this, arguments);
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    PSQShortText.prototype.componentDidMount = function () {
        this.viewSF.mounted && this.viewSF.mounted.apply(this, arguments);
    };
    PSQShortText.prototype.componentWillReceiveProps = function (nextProps) {
        this.viewSF.willReceiveProps && this.viewSF.willReceiveProps.apply(this, arguments);
    };
    PSQShortText.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.viewSF.shouldUpdate)
            return this.viewSF.shouldUpdate.apply(this, arguments);
        else
            return true;
    };
    PSQShortText.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.viewSF.didUpdate && this.viewSF.didUpdate.apply(this, arguments);
    };
    PSQShortText.prototype.componentWillUnmount = function () {
        this.viewSF.unmount && this.viewSF.unmount.apply(this, arguments);
    };
    PSQShortText.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._processEvent(eventName, args, 4, monikerCallback);
    };
    PSQShortText.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._processEvent(eventName, args, 2, function () { });
    };
    PSQShortText.prototype._processEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.viewSF.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                self_1.viewSF.events[eventName].apply(self_1, combinedArgs);
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    PSQShortText.prototype._renderView = function () {
        var _this = this;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var root_handler = function () {
            return [
                React.createElement(PSQImage_1.PSQImage, { key: 0, imageUrl: (_this.state.hasOwnProperty('question') ? _this.state.question : _this.props.question).attachment }),
                React.createElement(player_rich_text_viewer_1.default, { key: 1, html: (_this.state.hasOwnProperty('questionText') ? _this.state.questionText : _this.props.questionText), allowedTags: (_this.state.hasOwnProperty('constants') ? _this.state.constants : _this.props.constants).PRTV_ALLOWED_TAGS, allowedAttributes: (_this.state.hasOwnProperty('constants') ? _this.state.constants : _this.props.constants).PRTV_ALLOWED_ATTRIBUTES }),
                React.createElement(GridLayout_1.GridLayout, { key: 2, gutterHorizontal: "Medium", gutterVertical: "Small", children: [
                        React.createElement(GridCol_1.GridCol, { key: 0, width: "12", widthForSm: "6", children: [
                                React.createElement(TextboxStateWrapper_1.TextboxStateWrapper, { key: 0, ariaLabel: (_this.state.hasOwnProperty('questionText') ? _this.state.questionText : _this.props.questionText), id: (_this.state.hasOwnProperty('question') ? _this.state.question : _this.props.question).questionId, type: "Text", height: "Xsmall", maxLength: 400, value: (_this.state.hasOwnProperty('value') ? _this.state.value : _this.props.value), errorMessage: (_this.state.hasOwnProperty('question') ? _this.state.question : _this.props.question).errorMessage, onChange: _this._proxyEvent("onChange") })
                            ] })
                    ] })
            ];
        };
        return root_handler();
    };
    PSQShortText.prototype.render = function () {
        return (React.createElement("div", { className: "p-viewSF-psqshorttext" }, this._renderView()));
    };
    PSQShortText.defaultProps = {
        question: null, errorMessage: null,
        onChange: function () { }
    };
    return PSQShortText;
}(React.Component));
exports.PSQShortText = PSQShortText;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["PSQShortText"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/PSQShortText/PSQShortText.js
// module id = 719
// module chunks = 0